import { render, staticRenderFns } from "./StoryHead.vue?vue&type=template&id=332dd26b&"
import script from "./StoryHead.vue?vue&type=script&lang=js&"
export * from "./StoryHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports